<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card>
      <b-col xl="12" lg="12" md="12" sm="12">
        <b-button variant="danger" class="ml-4 float-right" @click="goBack">Voltar</b-button>
        <h3>&nbsp;Setores - {{moment(datainicial).format("DD/MM/YYYY")}} à {{moment(datafinal).format("DD/MM/YYYY")}}</h3>
      </b-col>
    </b-card>
    <b-row>
      <b-col cols="12">
        <b-card style="padding-bottom: 0!important;">
          <b-row>
            <b-col cols="12" class="mt-3">
              <b-form-group>
                <b-input-group prepend="Pesquisar">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-row>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-form-group>
                    <b-input-group prepend="Quantidade por Página">
                      <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions"></b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col xl="6" lg="6" md="12" sm="12">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12">
        <b-card>
          <b-table
            bordered
            small
            hover
            head-variant="light"
            style="margin-bottom: 0!important; padding-bottom: 0!important;"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template
              slot="totalcusto"
              slot-scope="data"
            >R$ {{(data.item.totalcusto).toLocaleString('pt-BR') }}</template>
            <template
              slot="totalvenda"
              slot-scope="data"
            >R$ {{(data.item.totalvenda).toLocaleString('pt-BR') }}</template>
            <template
              slot="lucro"
              slot-scope="data"
            >R$ {{(data.item.lucro).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</template>
            <template slot="perclucro" slot-scope="data">{{ data.item.perclucro }}%</template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";
import Loading from "vue-loading-overlay";


export default {
  components: {
    moment,
    Loading
  },
  data: _ => {
    return {
      items: [],
      fields: [
        {
          key: "codigo",
          label: "Código",
          sortable: false,
          sortDirection: "desc"
        },
        {
          key: "descricao",
          label: "Descrição",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "totalcusto",
          label: "Custo",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "totalvenda",
          label: "Venda",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "lucro",
          label: "Lucro",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "perclucro",
          label: "Percentual Lucro",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      isLoading: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      datainicial: null,
      datafinal: null
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },

  async beforeMount() {
    this.isLoading = true;
    this.datainicial = localStorage.getItem("datainicial_analise");
    this.datafinal = localStorage.getItem("datafinal_analise");
    await this.receberSetores();
    this.getRowCount(this.items);
    this.isLoading = false;
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    getRowCount(items) {
      this.totalRows = items.length;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async receberSetores() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/vendas-por-setor/${
            this.datainicial
          }/${this.datafinal}/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            var data = response.data.data;
            var arr = [];
            for (let i = 0; i < data.length; i++) {
              const e = data[i];
              const custo = Number(e.totalcusto).toLocaleString("pt-BR");
              const venda = Number(e.totalvenda).toLocaleString("pt-BR");
              arr.push({
                codigo: e.codigo,
                descricao: e.descricao,
                totalcusto: custo,
                totalvenda: venda,
                lucro: Number(
                  parseFloat(e.totalvenda) - parseFloat(e.totalcusto)
                ).toLocaleString("pt-BR"),
                perclucro: (
                  ((
                    parseFloat(e.totalvenda) - parseFloat(e.totalcusto)
                  ).toFixed(2) *
                    100) /
                  parseFloat(e.totalvenda)
                )
                  .toFixed(2)
                  .replace(/\./g, ",")
              });
            }
            this.items = arr;
          }
        });
    }
  }
};
</script>

<style>
</style>